import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 28;

export const migration_27_28:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component: {name}} = boxSnapshot;

                        if( name === 'RadioButtonGroup' || name === 'Checkbox' || name === 'Switch')
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((propSnapshot:any) =>
                            {
                                if( propSnapshot.name === 'model' )
                                {
                                    setControlBgColorValue(propSnapshot._value);
                                    setSelectedColorValue(propSnapshot._value);

                                    setControlBgColorBindPaths(propSnapshot._bindGroups, designState.bindings);
                                    setSelectedColorBindPaths(propSnapshot._bindGroups, designState.bindings);
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function setControlBgColorValue(value:any)
{
    value.controlBgColor = {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#f5f8fa'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 1
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': true
        }
    };
}

function setSelectedColorValue(value:any)
{
    value.selectedColor = {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#137cbd'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 1
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': true
        }
    };
}

function setControlBgColorBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');

    mainBindGroup.rootBindItem.paths[0]['a8599ec1-d06f-4b6c-9469-25ddd6fe5c47'] = {
        'id': 'a8599ec1-d06f-4b6c-9469-25ddd6fe5c47',
        'path': 'controlBgColor',
        'templatePath': 'controlBgColor',
        'paths': [
            {
                '86769500-ff32-4bb2-89b5-54c90e2e8e60': {
                    'id': '86769500-ff32-4bb2-89b5-54c90e2e8e60',
                    'path': 'color',
                    'templatePath': 'controlBgColor.color',
                    'paths': [
                        {
                            '517d3d7d-03f3-4fe2-977e-8eddf0254aef': {
                                'id': '517d3d7d-03f3-4fe2-977e-8eddf0254aef',
                                'path': 'hex',
                                'templatePath': 'controlBgColor.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            'daac5bfd-390d-4551-b0c0-9142a7a6491b': {
                                'id': 'daac5bfd-390d-4551-b0c0-9142a7a6491b',
                                'path': 'alpha',
                                'templatePath': 'controlBgColor.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '5ef04671-ddd9-488d-bed9-6e465e1d3e80': {
                    'id': '5ef04671-ddd9-488d-bed9-6e465e1d3e80',
                    'path': 'visibility',
                    'templatePath': 'controlBgColor.visibility',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}

function setSelectedColorBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');

    mainBindGroup.rootBindItem.paths[0]['8af8a17d-9a1e-4f3c-8c28-fb48976be521'] = {
        'id': '8af8a17d-9a1e-4f3c-8c28-fb48976be521',
        'path': 'selectedColor',
        'templatePath': 'selectedColor',
        'paths': [
            {
                'b87601ae-cea5-4166-b31b-d8f73e986f44': {
                    'id': 'b87601ae-cea5-4166-b31b-d8f73e986f44',
                    'path': 'color',
                    'templatePath': 'selectedColor.color',
                    'paths': [
                        {
                            '7fc23ed4-a096-4338-b028-42abba371904': {
                                'id': '7fc23ed4-a096-4338-b028-42abba371904',
                                'path': 'hex',
                                'templatePath': 'selectedColor.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            'ab150bf1-afa0-4040-a92b-65d84e8ce8b4b': {
                                'id': 'ab150bf1-afa0-4040-a92b-65d84e8ce8b4b',
                                'path': 'alpha',
                                'templatePath': 'selectedColor.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '878aa14b-b535-468e-958b-78e25d9441b9': {
                    'id': '878aa14b-b535-468e-958b-78e25d9441b9',
                    'path': 'visibility',
                    'templatePath': 'selectedColor.visibility',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}
